import * as tslib_1 from "tslib";
import { ControlHelper } from "../../../../form/src/common/controls/control-helper";
import { FormBuilderHelper } from "../../../../form/src/renderer/controls/form-builder-helper";
import { Prop, Vue, Watch } from "vue-property-decorator";
import * as schema from "../../schema";
import { FormControlOptionsService } from "../services";
import { FormControlType } from "../typings";
import { FormRendererHelper } from "./form-renderer-helper";
export class FormRenderer extends Vue {
    constructor() {
        super(...arguments);
        this._formControlMap = {};
    }
    get controller() {
        return this._controller;
    }
    get formControlMap() {
        return this._formControlMap;
    }
    findFormControls(keys) {
        return Object.keys(this._formControlMap || {})
            .filter((k) => {
            if (keys) {
                return keys.indexOf(k) > -1;
            }
            return true;
        })
            .map((k) => this._formControlMap[k]);
    }
    setControls(controls, oldControls) {
        if (!controls || controls === oldControls || controls.length === 0) {
            return;
        }
        let formControls = [];
        FormRendererHelper.findFormControl(controls, formControls);
        this._controller = FormRendererHelper.buildController(controls);
        const map = {};
        formControls.filter((c) => c.key)
            .forEach((c) => (map[c.key] = c));
        this._formControlMap = map;
    }
    convertOwner(owner) {
        owner.type = FormControlType.StaffSelector;
        owner.required = true;
        const options = FormControlOptionsService.buildFor(owner.type, owner.options);
        if (options) {
            options.defaultValueType = schema.StaffSelectorValueType.Originator;
            owner.options = options;
        }
    }
    render(h, mobile) {
        if (!this.controls || !this.controls.length) {
            return;
        }
        const children = this.controls.map((c) => FormRendererHelper.render(h, c, mobile, this));
        const tabs = this.findFormControls().find((c) => c.type === FormControlType.ReverseRelevance &&
            c.options.listDisplayMode === "tabs");
        if (tabs) {
            return h("div", children);
        }
        else {
            return h("div", [h("div", this.$slots.default), ...children]);
        }
    }
    validate(excludes) {
        if (!this.controller) {
            return true;
        }
        return this.controller.validate(excludes);
    }
    getErrors() {
        if (!this.controller) {
            return null;
        }
        return this.controller.errors;
    }
    getErrorMessage(controlId, errCode, parentId) {
        if (!controlId) {
            return "";
        }
        let control = this._formControlMap[parentId || controlId];
        if (control.controller.value === '' || control.controller.value === null) {
            return this.$t('cloudpivot.form.renderer.tip.requiredError').toString();
        }
        let parent = control;
        if (!control) {
            return "";
        }
        if (parentId) {
            // ;
            const col = parent.columns.find((c) => c.key === controlId);
            if (!col) {
                return "";
            }
            // control = (control.controller as any).children[0].children[controlId] as any
            control = col;
        }
        const locale = this.$i18n.locale;
        let msg = FormRendererHelper.getErrorMessage(control, errCode, locale) || "";
        if (parentId) {
            msg = ControlHelper.getControlLabel(parent, locale) + " " + msg;
        }
        return msg;
    }
    getValue() {
        console.log(this.controller, this.controls);
        if (this.controller) {
            return this.controller.value;
        }
    }
    getOpValue(reset) {
        let res = {};
        this.controls.forEach((el) => {
            if (el.children && Array.isArray(el.children)) {
                el.children.forEach((item) => {
                    if (item.children && Array.isArray(item.children)) {
                        item.children.forEach((item) => {
                            reset ? res[item.key] = item.defaultOp : res[item.key] = item.op;
                        });
                    }
                });
            }
        });
        return res;
    }
    reset() {
        this.findFormControls().forEach((c) => {
            if (c.controller) {
                const value = FormBuilderHelper.getControlValue(c);
                FormBuilderHelper.resetOpValue(c);
                c.controller.value = value;
            }
        });
    }
    clear() {
        this.findFormControls().forEach((c) => {
            //视图设计中查询条件配置的不显示字段的值不清空
            if (c.controller && c.options && c.options.visible) {
                c.controller.value = null;
            }
        });
    }
    edit(keys) {
        this.setWritable(true, keys);
    }
    readonly(keys) {
        this.setWritable(false, keys);
    }
    setWritable(edit, keys) {
        this.findFormControls(keys)
            .filter((c) => !FormRendererHelper.isSystem(c.type))
            .forEach((control) => {
            if (control.type === FormControlType.Sheet) {
                control.edit = edit;
            }
            else {
                if (this._controller) {
                    const ctrl = this._controller.findChild(control.key);
                    if (ctrl) {
                        if (control.writable === true) {
                            ctrl.readonly = !edit;
                        }
                        // @ts-ignore
                        ctrl.setReadonlyOver = true;
                    }
                }
            }
        });
    }
}
tslib_1.__decorate([
    Prop()
], FormRenderer.prototype, "controls", void 0);
tslib_1.__decorate([
    Prop({ default: () => [] })
], FormRenderer.prototype, "dataItems", void 0);
tslib_1.__decorate([
    Prop()
], FormRenderer.prototype, "formPermission", void 0);
tslib_1.__decorate([
    Watch("controls", {
        immediate: true,
    })
], FormRenderer.prototype, "setControls", null);
